export default {
  GY: {
    ts: '提示',

    qw: '前往',
    qr: '确认',
    qx: '取消',

    hd: '好的',

    qdl: '去登录',
    byl: '不用了',
  },
  GYTS: {
    ts0: '与服务器连接失败',
    xdl: '该功能需登陆后访问，是否去登录？',
    ts1: '功能正在开发中，将在后期陆续开放',
    ts2: '功能暂未启用',
    ts3: '没有更多了',
    ts4: '请稍候...',
    ts5: '加载中',
    ts6: '获取登录信息失败！',
  },
  mvp: {
    ddrttx: '读懂人体信号',
    sy: '首页',
    xhlr: '信号录入',
    xhcl: '信号处理',
    csk: '常识库',
    wd: '我的',
    dl: '登录'
  },
  SURV: {
    ts1: '请仔细阅读以下注意事项',
    jcxx: '基础信息',
    mustInputName: '您必须需要输入您的姓名信息',
    mustInputPhone: '您必须需要输入您的联系方式',
    mustInputHeartRate: '您必须需要输入您的心率，单位次/分钟',
    invalidAge: '请用数字输入您的年龄',
    invalidHeight: '身高请以数字方式输入，单位厘米。',
    invalidWeight: '体重请以数字方式输入，单位千克',
    invalidHeartRate: '心率以数字方式输入，单位次/分钟',
    registerPrompt: '是否注册为的会员？您可以更方便的查询自己的档案',
    goRegister: '去注册',
    hasAccount: '已有帐号',
    goLogin: '去登录',
    submitSuccess: '提交成功，点击确认去查看信号结果。',
    submitPreviewFailed: '提交预览数据失败了',
    submitSuccessMsg: '提交成功',
    mygw: '您当前尚未绑定专属顾问，系统将为您推荐一位顾问。提交前您可自由更换。',
    mygw2: '您当前尚未绑定专属顾问，点击按钮可选择专属顾问。',
    modifySuccessMsg: '修改成功',
    registerSuccess: '注册成功！',
    loginFailed: '登录失败',
    name: '姓名',
    qsrName: '请输入您的姓名',
    age: '年龄',
    qsrAge: '请输入您的年龄',
    contact: '联系方式',
    qsrContact: '请输入您的联系方式',
    gender: '性别',
    nan: '男',
    nv: '女',
    height: '身高(cm)',
    qsrHeight: '请输入您的身高',
    weight: '体重(kg)',
    qsrWeight: '请输入您的体重',
    heartRate: '心率(HR)',
    qsrHeartRate: '请输入您的心率',
    occupation: '职业',
    qsrOccupation: '请输入您的职业',
    femaleRelated: '女性相关',
    menstruation: '月经',
    isPregnant: '是否怀孕',
    iAgree: '我同意',
    clean: '清空',
    submit: '提交',
    confirmModify: '确认修改',
    returnModify: '返回修改',
    confirmSubmit: '确认提交',
    tip: '提示',
    continueSubmit: '都不需要，继续提交',
    qsr: '请输入',
    zztj: '正在提交',
    zzsc: '正在上传',
    uploadSuccess: '上传成功',
    uploadFailed: '上传失败',
  },
  SPI: {
    jkzz: '健康自助',
    jkgw: '健康顾问',

    jkgwq: '健康顾问请前往',
  },
  KBI: {
    dsi: '典型信号释义',
    bcw: '本草性味及药证',
    jfj: '医圣经方集',
  },
  MMT: {
    wdgw: '我的顾问',
    dlzc: '登录/注册',
    xgjbxx: '修改基本信息',
    xgmm: '修改密码',
    xhtxjl: '就诊记录',
    yy: '语言',
    tcdl: '退出登录',
    zztc: '正在退出',
    hqgylbsb: '获取‘关于’列表失败',
    qrtcdlm: '确认退出登录吗？',
  },
  ULV: {
    yhdl: '用户登录',
    zzdl: '正在登录',
  },
  LF: {
    dlyx: '登录邮箱',
    qsrnddlyx: '请输入您的登录邮箱',
    qsrdlyx: '请输入登录邮箱',
    qsrzqyxgs: '请输入正确的邮箱格式',
    dlmm: '登录密码',
    qsrmm: '请输入密码',
    mmcd: '密码长度最少是6位',
    dl: '登录',
    myzh: '没有账号',
    wjmm: '忘记密码',
    zcyx: '注册邮箱',
    qsrzcyx: '请输入注册邮箱',
    fsczmmyj: '发送重置密码邮件',
  },
  URR: {
    yhzc: '用户注册',
    zzzc: '正在注册',
  },
  RF: {
    dlyx: '登录邮箱',
    qsrnddlyx: '请输入您的登录邮箱',
    qsrdlyx: '请输入登录邮箱',
    qsrzqyxgs: '请输入正确的邮箱格式',
    dlmm: '登录密码',
    qsrmm: '请输入密码',
    mmcd: '密码长度最少是6位',
    qrmm: '确认密码',
    qzcsrmm: '请再次输入密码',
    lcsrdmmbyz: '两次输入的密码不一致',
    yzm: '验证码',
    qsryzm: '请输入验证码',
    yzmcd: '验证码长度为6位',
    zc: '注册',
    yyzh: '已有账号',
    qdl: '去登录',
    hqyzm: '获取验证码',
    fscg: '发送成功，请前往邮箱查收!',
    fscgts: '发送成功',
    cxhq: '重新获取',
    hqyzm: '获取验证码',
  },
  SCV: {
    jbxx: '基本信息',
    xm: '姓名',
    nl: '年龄',
    lxfs: '联系方式',
    xb: '性别',
    sg: '身高',
    tz: '体重',
    xl: '心率',
    zy: '职业',
    sfz: '身份证',
    qx: '取消',
    jzl: '加重了',
    jql: '减轻了',
    xsl: '消失了',
    zzjz: '正在加载',
    zztj: '正在提交',
    fkcg: '反馈成功',
    tjfkccl: '提交反馈出错了',
    zzhqsj: '正在获取数据',
    zzclsj: '正在处理数据',
  },
  UPI: {
    changePassword: "修改密码",
    oldPassword: "原密码",
    enterOldPassword: "请输入原密码",
    oldPasswordEmpty: "原密码不能为空",
    newPassword: "新密码",
    enterNewPassword: "请输入新密码",
    newPasswordEmpty: "新密码不能为空",
    passwordMinLength: "密码长度最少是6位",
    confirmPassword: "确认新密码",
    reEnterNewPassword: "请再次输入新密码",
    confirmPasswordEmpty: "确认新密码不能为空",
    passwordMismatch: "两次输入的密码不一致",
    save: "保存",
    updating: "正在修改",
    updateSuccess: "修改成功",
    updateFail: "修改失败"
  },
  PIV: {
    modifyInfo: "修改信息",
    fullName: "姓名",
    enterFullName: "请输入姓名",
    age: "年龄",
    enterAge: "请输入年龄",
    gender: "性别",
    selectGender: "请选择性别",
    male: "男",
    female: "女",
    height: "身高(cm)",
    enterHeight: "请输入身高",
    occupation: "职业",
    enterOccupation: "请输入职业",
    phone: "联系方式",
    enterPhone: "请输入联系方式",
    weight: "体重(kg)",
    enterWeight: "请输入体重",
    save: "保存",
    saving: "正在保存",
    updateSuccess: "修改成功",
    updateFail: "修改失败，请重试!",
    nameRequired: "您必须需要输入您的姓名信息",
    phoneRequired: "您必须需要输入您的联系方式",
    invalidAge: "请用数字输入您的年龄",
    invalidHeight: "身高请以数字方式输入，单位厘米。",
    invalidWeight: "体重请以数字方式输入，单位千克"
  },
  SRL: {
    signalRecords: "信号记录",
    diagnosing: "诊断中",
    viewSignal: "查看信号",
    viewPrescription: "查看处方",
    feedback: "我要反馈",
    again: '再次诊断',
    loginRequiredTitle: "提示",
    loginRequiredMessage: "该功能需要您登陆后使用。",
    goToLogin: "去登陆",
    noMoreData: "没有更多数据了",
    pullRefreshText: "释放立即刷新",
    loadingText: "加载中..."
  },
  UFB: {
    userFeedback: "用户反馈",
    loading: "正在加载",
    tjfk: "提交反馈",
    submittingFeedback: "正在提交反馈",
    feedbackSuccess: "反馈成功",
    feedbackError: "提交反馈出错了",
    editFeedback: "修改反馈",
    deleteFeedback: "删除此条",
    saveChanges: "保存修改",
    savingChanges: "正在保存修改",
    editSuccess: "修改成功",
    editError: "修改反馈出错了",
    deleteSuccess: "删除成功",
    deleteError: "删除反馈出错了",
    typeFeedbackPlaceholder: "键入要反馈的内容",
    editFeedbackPlaceholder: "修改反馈内容",
    savingChanges: "正在保存修改",
    deleting: "正在删除",
    feedbackEmpty: "反馈内容不能为空",
  },
  SRD: {
    prescription: "处方",
    diagnosisAnalysis: "症状信号分析",
    consultantNotes: "顾问备注",
    prescriptionDetails: "药方",
    cg: '共',
    cw:'味',
    cf: '副',
    cmr: '每日',
    crf: '日服',
    cc: '次',
    hz: '回诊',
  },
  GYY: {
    jz: '公益捐助和救助',
  },
  WDGW: {
    sb: '获取顾问列表失败！',
    sb1: '更换顾问失败！',
    cg: '更换成功',
  },
  ABO:{
    aboutAs: '关于我们',
  }

}